export default function convertToT(value) {
    return JSON.parse(value);
}
